import React, { memo, useCallback, useEffect, useState } from 'react'
import { Checkbox, Col, Input, Row } from 'antd'
import { isEmpty } from 'lodash'

import { useQueryParams } from '../../../core/hooks'

const IngredientSearchByKeyword = () => {
  const { keywordSearchTerm, areDiscardedKeywordsIncluded, setQueryParams } =
    useQueryParams()
  const [searchTerm, setSearchTerm] = useState(keywordSearchTerm)
  const [areDiscardedIncluded, setAreDiscardedIncluded] = useState(
    areDiscardedKeywordsIncluded,
  )

  const handleOnInputChange = useCallback(
    event => setSearchTerm(event.target.value),
    [],
  )

  const handleSearch = useCallback(
    () =>
      setQueryParams({
        keywordSearchTerm: searchTerm,
        areDiscardedKeywordsIncluded: isEmpty(searchTerm)
          ? false
          : areDiscardedIncluded,
      }),
    [setQueryParams, searchTerm, areDiscardedIncluded],
  )

  const handleOnCheckboxChange = useCallback(
    event =>
      setQueryParams({
        keywordSearchTerm: searchTerm,
        areDiscardedKeywordsIncluded: event.target.checked,
      }),
    [searchTerm, setQueryParams],
  )

  useEffect(() => {
    setSearchTerm(keywordSearchTerm)
    setAreDiscardedIncluded(areDiscardedKeywordsIncluded)
  }, [keywordSearchTerm, areDiscardedKeywordsIncluded])

  return (
    <Row gutter={[16, 16]}>
      <Col span={6}>
        <Input.Search
          value={searchTerm}
          placeholder="Search ingredients by keyword"
          onChange={handleOnInputChange}
          onSearch={handleSearch}
          allowClear
        />
        <Checkbox
          style={{ margin: '0.5rem 0' }}
          disabled={isEmpty(searchTerm)}
          checked={areDiscardedIncluded}
          onChange={handleOnCheckboxChange}
        >
          Include discarded keywords
        </Checkbox>
      </Col>
    </Row>
  )
}

export default memo(IngredientSearchByKeyword)
